export const supportedLngs = {
  en: "English",
  it: "Italiano",
};
